import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
} from "@mui/material";
import Button from "../../components/Button/Button";
import { AddCircle, CheckCircle, MoreVert } from "@mui/icons-material";
import {
  get_return_status,
  get_sales_order_report,
  update_sales_order_report,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-simple-toasts";

export default function SaleReport() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);
  const [allData, setAllData] = React.useState([]);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  // const [searchKeyStatus, setSearchKeyStatus] = React.useState("");

  const searchData = (data, searchKey) => {
    var _data = [];
    if (searchKey != "") {
      for (var i = 0; i < data.length; i++) {
        if (
          data[i].sales_order_id
            .toUpperCase()
            .indexOf(searchKey.toUpperCase()) > -1
        ) {
          _data.push(data[i]);
        }
      }
    } else {
      _data = [...data];
    }

    return _data;
  };
  // const searchDataStatus = (data, searchKey) => {
  //   var _data = [];
  //   if (searchKey != "") {
  //     for (var i = 0; i < data.length; i++) {
  //       if (
  //         data[i].status.toUpperCase().indexOf(searchKey.toUpperCase()) > -1
  //       ) {
  //         _data.push(data[i]);
  //       }
  //     }
  //   } else {
  //     _data = [...data];
  //   }

  //   return _data;
  // };

  const handleSearch = (event) => {
    setSearchKey(event.target.value);
    var _data = searchData(allData, event.target.value);
    setListData(_data);
    setPageNum(0);
    // setTotalList(_data.length);
  };

  // const handleSearchStatus = (event) => {
  //   setSearchKeyStatus(event.target.value);
  //   var _data = searchDataStatus(allData, event.target.value);
  //   setListData(_data);
  //   setPageNum(0);
  //   setTotalList(_data.length);
  // };

  const [returnStatus, setReturnStatus] = React.useState([]);

  const getStatus = () => {
    get_return_status().then((json) => {
      setReturnStatus(json.data);
    });
  };

  React.useEffect(() => {
    getStatus();
  }, []);
  const [selectedStatus, setSelectedStatus] = React.useState("Open");

  const handleChooseStatus = (e) => {
    setSelectedStatus(e.target.value);
    window.localStorage.setItem("issuelog_status", e.target.value);
  };

  const [dateFrom, setDateFrom] = React.useState("");

  const handleChangeDateFrom = (event) => {
    const value = event.target.value;
    setDateFrom(value);
    window.localStorage.setItem("issuelog_datefrom", value);

  };

  const [dateTo, setDateTo] = React.useState("");

  const handleChangeDateTo = (event) => {
    const value = event.target.value;
    setDateTo(value);
    window.localStorage.setItem("issuelog_dateto", value);
  };

  const [loading, setLoading] = React.useState(false);
  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);
  const [imageData, setImageData] = React.useState(null);
  const [openVariantImg, setOpenVariantImg] = React.useState(false);
  const [infiniteStatus, setInfiniteStatus] = React.useState(true);

  const handleOpenVariantImage = (e) => {
    // console.log(e)
    if (e.length < 5) {
      setInfiniteStatus(false);
    } else {
      setInfiniteStatus(true);
    }
    setOpenVariantImg(true);
    setImageData(e);
  };
  const handleCloseVariantImage = (value) => {
    setOpenVariantImg(false);
    setImageData(null);
  };

  const [listData, setListData] = React.useState(null);
  const [isInitialized, setIsInitialized] = React.useState(false);

  const getData = () => {
    setLoading(true);
    get_sales_order_report({
      page: pageNum,
      dateFrom: dateFrom,
      dateTo: dateTo,
      status: selectedStatus
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setAllData(json.data);
      var _data = searchData(json.data, searchKey);
      setListData(_data);
      setTotalList(json.total);
    });
  };

  // Load localStorage values on component mount
  React.useEffect(() => {
    const storedStatus = window.localStorage.getItem("issuelog_status");
    if (storedStatus) {
      setSelectedStatus(storedStatus);
    }

    const storedDateFrom = window.localStorage.getItem("issuelog_datefrom");
    if (storedDateFrom) {
      setDateFrom(storedDateFrom);
    }
    
    const storedDateTo = window.localStorage.getItem("issuelog_dateto");
    if (storedDateTo) {
      setDateTo(storedDateTo);
    }
    
    // Mark as initialized after loading localStorage values
    setIsInitialized(true);
  }, []); // Only run once on mount

  // Fetch data when parameters change, but only after initialization
  React.useEffect(() => {
    if (isInitialized) {
      getData();
    }
  }, [pageNum, sort, dateFrom, dateTo, selectedStatus, isInitialized]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const handleUpdateReport = (e) => {
    if (window.confirm("Mark this report as completed?")) {
      update_sales_order_report({
        sales_order_report_id: e.sales_order_report_id,
        // sort: sort
      }).then((json) => {
        getData();
        toast("Sales report status update to done");
        // setLoading(false);
        // setListData(json.table);
        // setTotalList(json.total);
      });
    }
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd="2rem">
              <div>
                <div className={classes.theFlexHeader}>
                  {/* <div className={classes.theHeaderSelect}>
                                        <FormInput
                                            // label="Username"
                                            textLabelColor="#000"
                                            // placeholder="Username"
                                            // name="username"
                                            bold="600"
                                            border="0"
                                            size="24px"
                                            value={location.pathname.replace(/[^A-Za-z]+/g, "")}
                                            select
                                            onChange={handleHeader}
                                        >
                                            <MenuItem value="sale">Sale Order</MenuItem>
                                            <MenuItem value="invoice">Invoice</MenuItem>
                                        </FormInput>
                                    </div> */}
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Issues Logged by Customer
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  >
                    {/* <a
                                            className={classes.theCustomActionBtn_}
                                            // className={classes.theCustomActionBtn}
                                            onClick={() => navigate("/createorder")}
                                        >
                                            <AddCircle sx={{ color: "#1A5386" }} />
                                            <Paragraph margin="0 0 0 .4rem">Create New Order</Paragraph>
                                        </a> */}
                    {/* <a
                                            className={classes.theCustomActionBtn_}
                                        // onClick={() => handleOpenStockMove()}
                                        >
                                            <ExitToApp sx={{ color: "#1A5386" }} />
                                            <Paragraph margin="0 0 0 .4rem">Export</Paragraph>
                                        </a> */}
                  </div>
                </div>
                <div
                  style={{
                    borderBottom: "2px solid #707070",
                    padding: ".2rem 0",
                  }}
                />
                <br />

                <div className={classes.theFlexAction}>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleSearch}
                      value={searchKey}
                    />
                  </div>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    {/* <FormInputNoLabel
                      placeholder="Search Status"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleSearchStatus}
                      value={searchKeyStatus}
                    /> */}
                    <FormInputSelect>
                      <Select
                        displayEmpty
                        inputProps={{
                          "aria-label": "Without label",
                        }}
                        value={selectedStatus}
                        onChange={handleChooseStatus}
                      >
                        {returnStatus != null &&
                          returnStatus.map((res) => (
                            <MenuItem value={res.status}>
                              {res.status}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormInputSelect>
                  </div>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeDateFrom}
                      value={dateFrom}
                      type="date"
                    />
                  </div>

                  <Paragraph bold="bold" color="#707070">
                    to
                  </Paragraph>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 20px" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeDateTo}
                      value={dateTo}
                      type="date"
                    />
                  </div>
                  {/* <div className={classes.theWx} style={{ margin: "0 20px 0 0" }}>
                                    <FormInputNoLabel
                                        placeholder="Search"
                                        border="1px solid #d7d7d7"
                                        br="6px"
                                        onChange={(e) => console.log(e.target.value)}
                                        value={searchKey}
                                        type="date"
                                    />
                                </div> */}
                  {/* <div className={classes.theWx}>
                                    <div className={classes.theFlex_}>
                                        <FormInputSelect>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={sort}
                                                // defaultValue={sort}
                                                onChange={handleChangeSort}
                                            >
                                                <MenuItem value="0" style={{ color: "#000" }}>
                                                    All Payment Type
                                                </MenuItem>
                                                <MenuItem value="1" style={{ color: "#000" }}>
                                                    Paid
                                                </MenuItem>
                                                <MenuItem value="2" style={{ color: "#000" }}>
                                                    On Hold
                                                </MenuItem>
                                                <MenuItem value="3" style={{ color: "#000" }}>
                                                    Cancelled
                                                </MenuItem>
                                            </Select>
                                        </FormInputSelect>
                                    </div>
                                </div> */}
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: "#1A5386" }}>
                            <TableRow>
                              {/* <TableCell style={{ borderRadius: "10px 0 0 10px" }} className={classes.theHeadTitle}>
                                    <Checkbox
                                        sx={{
                                            color: "#fff",
                                            '&.Mui-checked': {
                                                color: "#fff",
                                            },
                                        }} />
                                </TableCell> */}
                              <TableCell
                                style={{ borderRadius: "10px 0 0 10px" }}
                                className={classes.theHeadTitle}
                              >
                                Return Order ID
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                SO Number
                              </TableCell>

                              <TableCell className={classes.theHeadTitle}>
                                Customer
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Phone
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Reason
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Memo
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Status
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Images
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ borderRadius: "0 10px 10px 0" }}
                                className={classes.theHeadTitle}
                              >
                                {/* <MoreVert sx={{ color: "#fff" }} /> */}
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {listData != null &&
                              listData
                                .map((item, index) => {
                                  return (
                                    <TableRow>
                                      {/* <TableCell><Checkbox
                                          sx={{
                                              color: "#000",
                                              '&.Mui-checked': {
                                                  color: "#000",
                                              },
                                          }} /></TableCell> */}
                                      <TableCell
                                        className={classes.theUnderLineLabel}
                                        style={{
                                          textDecoration: "underline",
                                          // width: "20%"
                                        }}
                                        onClick={() =>
                                          navigate(
                                            "/salereturn/" +
                                              item.sales_order_id +
                                              "/" +
                                              item.sales_order_report_id
                                          )
                                        }
                                      >
                                        {item.sales_order_report_id != "" &&
                                        item.sales_order_report_id != null
                                          ? item.sales_order_report_id
                                          : "-"}{" "}
                                        View &#62;
                                      </TableCell>
                                      <TableCell
                                      // className={classes.theUnderLineLabel}
                                      >
                                        {item.sales_order_id != "" &&
                                        item.sales_order_id != null
                                          ? item.sales_order_id
                                          : "-"}
                                      </TableCell>
                                      <TableCell
                                        // className={classes.theUnderLineLabel}
                                        style={{
                                          width: "25%",
                                        }}
                                      >
                                        {item.customer != "" &&
                                        item.customer != null
                                          ? item.customer
                                          : "-"}
                                      </TableCell>

                                      <TableCell>
                                        {item.phone != "" && item.phone != null
                                          ? item.phone
                                          : "-"}
                                      </TableCell>
                                      <TableCell>
                                        {item.reason != "" &&
                                        item.reason != null
                                          ? item.reason
                                          : "-"}
                                      </TableCell>
                                      <TableCell>
                                        {item.description != "" &&
                                        item.description != null
                                          ? item.description
                                          : "-"}

                                        {/* {item.description != "" &&
                                        item.description != null
                                          ? item.description == "undefined" || item.description 
                                          : item.description == "undefined" &&  "-"} */}
                                      </TableCell>
                                      <TableCell>
                                        {item.status != "" &&
                                        item.status != null
                                          ? item.status
                                          : "-"}
                                      </TableCell>
                                      <TableCell>
                                        {item.images.length > 0 ? (
                                          <span
                                            onClick={() =>
                                              handleOpenVariantImage(
                                                item.images
                                              )
                                            }
                                            style={{
                                              textDecoration: "underline",
                                              color: "#1a5386",
                                            }}
                                          >
                                            View &#62;
                                          </span>
                                        ) : (
                                          <span
                                            style={{
                                              textDecoration: "underline",
                                              color: "#CCCCCC",
                                            }}
                                          >
                                            View &#62;
                                          </span>
                                        )}
                                      </TableCell>
                                      {/* <TableCell
                                                                            style={{
                                                                                width: "10%"
                                                                            }}
                                                                      
                                                                        >
                                                                            <div style={{
                                                                                background: item.is_solved === "0" ? "#1A5386" : "#CCCCCC",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItmes: "center",
                                                                                padding: "10px 0",
                                                                                borderRadius: "10px",
                                                                                margin: "0 0 10px",
                                                                                cursor: "pointer"
                                                                            }}
                                                                                onClick={() => item.is_solved === "0" ? handleUpdateReport(item) : toast("Report already resolved")}
                                                                            >
                                                                                <CheckCircle sx={{ color: "#fff" }} />
                                                                            </div>
                                                                        </TableCell> */}
                                    </TableRow>
                                  );
                                })}
                          </TableBody>
                        </Table>
                      </TableContainer>

                      <div
                        style={{
                          borderTop: "1px solid #707070",
                          borderBottom: "1px solid #707070",
                          margin: "1rem 0 0",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                        <TablePagination
                          // variant="outlined"
                          color="primary"
                          page={pageNum}
                          onPageChange={handleChangePage}
                          count={totalList}
                          // defaultPage={pageList}
                          rowsPerPage={10}
                          rowsPerPageOptions={[10]}
                          // count={10}
                        />
                      </div>
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />

                {imageData != null && (
                  <Dialog
                    onClose={handleCloseVariantImage}
                    open={openVariantImg}
                    fullWidth="true"
                    maxWidth="xl"
                  >
                    <DialogTitle>
                      <Paragraph color="#1A5386" bold="600" size="24px">
                        Attached Images
                      </Paragraph>
                    </DialogTitle>
                    <DialogContent>
                      <br />
                      <div className={classes.theSliderVariant}>
                        <Slider
                          dots={true}
                          speed={500}
                          slidesToShow={4}
                          slidesToScroll={4}
                          infinite={infiniteStatus}
                        >
                          {imageData.map((res) => (
                            <div>
                              <div className={classes.theImageBox}>
                                <div className={classes.theIBImg}>
                                  <img src={res.image} />
                                </div>
                                {/* <div className={classes.theRemove}
                                                                    onClick={() => handleDeleteImage(res)}>
                                                                    <Delete style={{ color: "#fff" }} />
                                                                </div> */}
                              </div>
                            </div>
                          ))}
                        </Slider>
                      </div>
                      <br />
                    </DialogContent>
                  </Dialog>
                )}
              </div>
            </Section>
          }
        />
      )}
    </React.Fragment>
  );
}
